<div class="modal fade show" style="display: block; padding-right: 15px;">
	<div class="modal-dialog modal-xl modal-full-screen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Image Library</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body">
                <p>Select your preferred image or upload a new one</p>

				<div class="image-library">
					<div class="text-end margin-bottom-20">
						<app-image-upload
                            [type]="type"
                            [ownerId]="ownerId" (imageUploaded)="appendImage($event)"></app-image-upload>
						<br />
					</div>

					<ng-container *ngIf="imageType">
						<button
								class="btn mb-2 me-2"
								[ngClass]="{'btn-success' : t.id === imageType.id}"
								*ngFor="let t of types" (click)="setType(t)">
							{{t.name}}
						</button>
					</ng-container>

					<ul dragula="roomImages" style="list-style: none" [(dragulaModel)]="images" (dragulaModelChange)="drop($event)">
						<li class="tile gallery-tile" *ngFor="let image of images | reverseArray; let i = index" style="float: left">
                            <div class="image-toolbar">
                                <div class="d-flex justify-content-around">
                                    <button class="btn btn-success"
                                            (click)="selectImage(image)">
                                        <i class="fa fa-mouse-pointer"></i>
                                    </button>
                                    <div class="btn-group ms-2"
                                         [ngClass]="{'show' : image.moveOpen}"
                                         role="group"
                                         (click)="toggleMoveMenu(image)">
                                        <button type="button" class="btn btn-primary dropdown-toggle">
                                            <i class="fa fa-arrows-alt"></i>
                                        </button>
                                        <div class="dropdown-menu" [ngClass]="{'show' : image.moveOpen}">
                                            <a class="dropdown-item" *ngFor="let t of types" (click)="move(image, t, i)">{{t.name}}</a>
                                        </div>
                                    </div>
                                    <button class="ms-2 btn btn-danger"
                                            (click)="copyUrl(image.url)">
                                        <i class="fa fa-copy"></i>
                                    </button>
<!--                                    <button class="ms-2 btn btn-danger btn-sm"-->
<!--                                            (click)="cropImage(image)">-->
<!--                                        <i class="fa fa-crop"></i>-->
<!--                                    </button>-->
                                    <button class="ms-2 btn btn-danger"
                                            (click)="delete(image)">
                                            <img src="assets/images/icon-trash.svg" class="text-danger images-trash">                                       
                                    </button>
                                </div>

                            </div>
							<img [src]="image.url + '?width=190'" />
						</li>
					</ul>


				</div>

			</div>

<!--			<div class="modal-footer">-->
<!--				<button type="button" class="btn btn-primary" (click)="save()">Save changes</button>-->
<!--			</div>-->
		</div>
	</div>
</div>
<app-image-delete *ngIf="(overlays$ | async).imageDelete" [modalData]="modalData" [modals]="modals" (modalResponse)=" deleteResponse($event)"></app-image-delete>

<div class="modal-backdrop fade show"></div>
<!-- <app-confirmation *ngIf="this.confirmationData.open" (complete)="delete($event)" [data]="confirmationData"></app-confirmation> -->







